var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as BettingModeActions from '../actions/BettingMode';
var initialState = {
    acceptIncrease: false,
    acceptDecrease: false,
    oneClickAmount: 50,
    isOneClickOn: false
};
export default function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case BettingModeActions.TOGGLE_ACCEPT_FACTOR_INCREASE:
            localStorage.setItem('acceptIncrease', !state.acceptIncrease);
            return __assign(__assign({}, state), { acceptIncrease: !state.acceptIncrease });
        case BettingModeActions.TOGGLE_ACCEPT_FACTOR_DECREASE:
            localStorage.setItem('acceptDecrease', !state.acceptDecrease);
            return __assign(__assign({}, state), { acceptDecrease: !state.acceptDecrease });
        case BettingModeActions.TOGGLE_ONE_CLICK_MODE:
            localStorage.setItem('isOneClickOn', !state.isOneClickOn);
            return __assign(__assign({}, state), { isOneClickOn: !state.isOneClickOn });
        case BettingModeActions.SET_ONE_CLICK_AMOUNT:
            localStorage.setItem('oneClickAmount', action.data);
            return __assign(__assign({}, state), { oneClickAmount: action.data });
        default:
            return state;
    }
    return initialState;
}



// WEBPACK FOOTER //
// ./src/reducers/bettingModeReducer.js